// extracted by mini-css-extract-plugin
module.exports = {"NumbersPad":"NumPad_NumbersPad__3nJNW"};